<template>
  <div>
    <v-dialog
      v-model="dialogConfidentialProccess"
      persistent max-width="450">
      <v-card>
        <v-card-title class="warning darken-2 white--text" primary-title>Processo privado</v-card-title>
        <v-card-text>Você não tem permissão para acessar o processo. Ao confirmar, essa janela será encerrada.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-1" flat @click="close()">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loader-dialog :showLoader="loading.show" message="Carregando processo..."/>
    <div class="show-folder" v-if="!isEmpty(folder)">
      <folder-sidebar v-if="!loading.show && folderViewMode !== 'presentation'"/>
      <folder-toolbar v-if="!loading.show" @searchDocument="searchDocument"/>
      <v-content v-if="!loading.show">
        <v-container
          class="ma-0 show-folder-container"
          v-if="folderViewMode === 'list'"
        >
          <list-mode
            :folder="folder"
            :documents="documentsFound"
            :searchDocumentString="searchDocumentString"
          />
        </v-container>
        <v-container v-if="folderViewMode === 'grid'">
          <grid-mode
            :folder="folder"
            :documents="documentsFound"
            :searchDocumentString="searchDocumentString"
          />
        </v-container>
        <presentation-mode v-if="folderViewMode === 'presentation'"/>
      </v-content>
      <div id="create">
        <v-speed-dial
          v-if="canAddDocuments()"
          v-model="showNewDocumentOptions"
          bottom
          right
          direction="top"
          transition="slide-y-reverse-transition"
        >
          <v-btn
            slot="activator"
            fab
            color="white"
            fixed
          >
            <v-icon>mdi-plus</v-icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-tooltip left>
            <v-btn slot="activator" icon color="blue darken-2" dark @click="showAttachDocumentsDialog = true">
              <v-icon>mdi-upload</v-icon>
            </v-btn>
            <span>Enviar Arquivos</span>
          </v-tooltip>
          <v-tooltip left>
            <v-btn icon slot="activator" color="blue darken-2" dark @click="newDocument('document')">
              <v-icon>mdi-file-outline</v-icon>
            </v-btn>
            <span>Novo Documento</span>
          </v-tooltip>
          <v-tooltip left>
            <v-btn icon slot="activator" color="blue darken-2" dark @click="newDocument('minute')">
              <v-icon>mdi-file-send</v-icon>
            </v-btn>
            <span>Nova Minuta</span>
          </v-tooltip>
        </v-speed-dial>
      </div>

      <new-document-and-minute-dialog
        :folderId="folder.id"
        :selectedState="selectedState"
        :show="showNewDocumentDialog"
        @closeNewDocumentDialog="showNewDocumentDialog = false"
        @documentCreated="onDocumentCreated"
      />

      <attach-documents-dialog
        :folderId="folder.id"
        :show="showAttachDocumentsDialog"
        @closeAttachDocumentsDialog="showAttachDocumentsDialog = false"
      />
    </div>
  </div>
</template>

<script>
import FolderSidebar from '@/components/folder/show/sidebar/FolderSidebar';
import FolderToolbar from '@/components/folder/show/toolbar/FolderToolbar';
import GridMode from '@/components/document/grid/GridMode';
import ListMode from '@/components/document/list/ListMode';
import PresentationMode from '@/components/document/presentation/PresentationMode';
import LoaderDialog from '@/components/LoaderDialog';
import NewDocumentAndMinuteDialog from '@/components/document/new/NewDocumentAndMinuteDialog';
import AttachDocumentsDialog from '@/components/document/new/AttachDocumentsDialog';
import {filter, isEmpty} from 'lodash';

export default {
  name: 'ShowFolder',
  components: {
    AttachDocumentsDialog,
    FolderSidebar,
    FolderToolbar,
    GridMode,
    ListMode,
    LoaderDialog,
    NewDocumentAndMinuteDialog,
    PresentationMode,
  },
  data() {
    return {
      isEmpty,
      documentsFound: [],
      searchDocumentString: '',
      selectedState: '',
      showNewDocumentOptions: false,
      showNewDocumentDialog: false,
      showAttachDocumentsDialog: false,
      url: '',
      dialogConfidentialProccess: false,
    };
  },
  mounted() {
    this.getFolder();
  },
  props: ['id'],
  computed: {
    user() {
      return this.$store.getters.user;
    },
    folder() {
      return this.$store.getters.activeFolder;
    },

    lastTransaction() {
      return this.folder.transactions.find(t => t.last_transaction = true);
    },
    documents() {
      return this.$store.getters.activeFolder.documents;
    },
    loading() {
      return this.$store.getters.loading;
    },
    folderViewMode() {
      return this.$store.getters.folderViewMode;
    },
  },
  watch: {
    folderViewMode() {
      return this.$store.getters.activeFolder;
    },
    documents(val) {
      this.documentsFound = val ? [...val] : [];
    },
  },
  methods: {
    areYouFolderOwner() {
      return !!(this.folder.current_owner && this.user && this.folder.current_owner.id === this.user.id);
    },
    canAddDocuments() {
      if (this.folder == null || this.folder.id == null ||
          this.user == null || this.user.id == null ||
          this.folder.folder_status.name === 'Arquivado') {
        return false;
      }
      if (isEmpty(this.lastTransaction)) {
        return this.areYouFolderOwner();
      }
      console.log('Last Transaction:', this.lastTransaction);
      return this.lastTransaction && this.lastTransaction.received && this.areYouFolderOwner();
    },
    changeMode(mode) {
      this.mode = mode;
    },

    getFolder() {
      this.$store.dispatch('toggleLoader', { show: true });
      this.$store.dispatch('getUser');
      this.$store.dispatch('getActiveFolder', { id: this.id })
        .then(() => {
          this.$store.dispatch('toggleLoader', { show: false });
        })
        .catch((error) => {
          this.$store.dispatch('toggleLoader', { show: true });
          if (error.response && error.response.status === 422) {
            this.dialogConfidentialProccess = true;
          } else {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              timeout: 0,
              color: 'default',
              message: error.response.data.message || error.response.data.error ||'Erro ao carregar processo',
              messageIcon: 'mdi-information-outline'
            });
          }
        });
    },
    expressionTest(item, value) {
      const expression = new RegExp(value, 'i');
      const propertyToSearch = 'name';
      return expression.test(item.document_type.name) || expression.test(item.docflow_number);
    },
    searchDocument(value) {
      this.searchDocumentString = value;
      const itemsFound = filter([...this.documents], item => (
        this.expressionTest(item, value)
      ));
      this.documentsFound = [...itemsFound];
    },
    onDocumentCreated({ documentId, documentModel }) {
      this.$router.push({ name: 'DocumentEditor', params: { folderId: this.folder.id, id: documentId }, query: { documentModel } });
    },
    newDocument(state) {
      this.showNewDocumentDialog = true;
      this.selectedState = state;
    },
    close() {
      window.close();
    },
  },
  beforeDestroy() {
    this.$store.dispatch('cleanFoldersData');
  },
};
</script>

<style lang="scss" scoped>
.show-folder {
  background: #fff;
  min-height: 100vh;
}

#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}

.show-folder-container {
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/folder/show/ShowFolder.vue